import { useRef } from 'react';
import './UploadButton.css';

const UploadButton = ({ handleCSVUpload }) => {
    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            handleCSVUpload(file);
        }
        event.target.value = '';
    };

    return (
        <div className="output-button">
            <div className="output-select-button">
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-labelledby="shareIconTitle"
                    stroke="var(--blue-font-color)"
                    strokeWidth="1.9"
                    strokeLinecap="square"
                    strokeLinejoin="miter"
                    fill="none"
                    color="var(--blue-font-color)"
                >
                    <title id="shareIconTitle">CSVアップロード</title>
                    <path d="M12 14V6" />
                    <path d="M9 8L12 5L15 8" />
                    <path d="M5 13V18H19V13" />
                </svg>
                <button className="blue" onClick={handleButtonClick}>
                    CSVアップロード
                </button>
                <input
                    type="file"
                    accept=".csv,text/csv"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                />
            </div>

        </div>
    )
}

export default UploadButton;
